import { useEffect } from 'react'

export default function NotificationToast() {
  useEffect(() => {
    // Toasts desativados
  }, [])

  return null
}